import React from 'react';
import { TreeNodeType } from '../../../../../../lib/types/types';
import BerichtAbschlussStartUpProjekte, { getFormStrucBerichtAbschlussStartUpProjekte } from './content/BerichtAbschlussStartUpProjekte';
import DurchfuehrungAbschlussStartUp, { getFormStrucDurchfuehrungAbschlussStartUp } from './content/DurchfuehrungAbschlussStartUp';
import FoerderZielenAbschlussStartUp, { getFormStrucFoerderZielenAbschlussStartUp } from './content/FoerderZielenAbschlussStartUp';
import OeffentlichkeitAbschlussStartUp, { getFormStrucOeffentlichkeitAbschlussStartUps } from './content/OeffentlichkeitAbschlussStartUp';
import ResuemeeMassnahmeAbschlussStartUp, { getFormStrucResuemeeMassnahmeAbschlussStartUp } from './content/ResuemeeMassnahmeAbschlussStartUp';
import VerstetigungAbschlussStartUp, { getFormStrucVerstetigungAbschlussStartUp } from './content/VerstetigungAbschlussStartUp';

export const TreeStructureAbschlussStartUp = (): TreeNodeType[] => {
	let treeNodes: TreeNodeType[] = [
		{
			label: 'Durchführung des Vorhabens',
			content: <DurchfuehrungAbschlussStartUp />,
			formStruc: getFormStrucDurchfuehrungAbschlussStartUp(),
		},
		{
			label: 'Beitrag zu den angestrebten Förderzielen',
			content: <FoerderZielenAbschlussStartUp />,
			formStruc: getFormStrucFoerderZielenAbschlussStartUp(),
		},
		{
			label: 'Öffentlichkeitsarbeit, Marketingmaßnahmen',
			content: <OeffentlichkeitAbschlussStartUp />,
			formStruc: getFormStrucOeffentlichkeitAbschlussStartUps(),
		},
		{
			label: 'Verstetigung und Ausblick',
			content: <VerstetigungAbschlussStartUp />,
			formStruc: getFormStrucVerstetigungAbschlussStartUp(),
		},
		{
			label: 'Resümee zu Effektivität und Effizienz der Maßnahme',
			content: <ResuemeeMassnahmeAbschlussStartUp />,
			formStruc: getFormStrucResuemeeMassnahmeAbschlussStartUp(),
		},
		{
			label: 'Abschluss',
			content: <BerichtAbschlussStartUpProjekte />,
			formStruc: getFormStrucBerichtAbschlussStartUpProjekte(),
		},
	];

	return treeNodes;
};
